import { Loading } from "@/app/components/LoadingFilters";

export const LoadingSelectFilter = () => {
  return (
    <div className="grid gap-2">
      <div className="flex items-center">
        <Loading className="h-4 w-4" />
        <Loading className="ml-2 h-5 w-24" />
      </div>
      <div className="flex items-center">
        <Loading className="h-4 w-4" />
        <Loading className="ml-2 h-5 w-32" />
      </div>
      <div className="flex items-center">
        <Loading className="h-4 w-4" />
        <Loading className="ml-2 h-5 w-20" />
      </div>
    </div>
  );
};
